import { jsx } from "react/jsx-runtime";
import { dynamic } from "@zillow/frontier/dynamic";
import { remote } from "@zillow/frontier/import";
const AgentShoppingRemote = dynamic(() => remote("agent-shopping-subapp/AgentShoppingActivationLandingPage"), {
  render: "ssr",
  type: "remote",
  module: "agent-shopping-subapp/AgentShoppingActivationLandingPage",
  webpack: () => [require.resolve("@zillow/frontier/dynamic"), "agent-shopping-subapp/AgentShoppingActivationLandingPage"]
});
const AgentShoppingBlock = (props) => {
  return /* @__PURE__ */ jsx(AgentShoppingRemote, { ...props });
};
export {
  AgentShoppingBlock as default
};
